/**
 * Checks if the given participant is a contact.
 *
 * @param {object} participant - The participant object to check.
 * @return {boolean} Returns true if the participant is a contact, false otherwise.
 */
export function isParticipantContact(participant) {
    return participant?.is_contact ?? false;
}
